import {AbstractEvent} from "@/modules/base/events";
import {Team} from "@/modules/team/entity";

export class BeforeTeamCreatedEvent extends AbstractEvent {
  constructor(
    public team: Team,
  ) {
    super();
  }
}